import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'
import { getRequest, postRequest, patchRequest } from '@/plugins/api-axios'
import AppMixin from './app'
import Role from '@/views/Authorization/models/role'
import Permission from '@/views/Authorization/models/permission'

@Mixin
export default class AuthorizationMixin extends AppMixin {
    url_authorization = process.env.VUE_APP_AUTHORIZATION_BASE_URL
    roles: Array<Role> = []
    rolePermissions: Record<string, Permission> = {}

    get headersmixins() {
        return {
            'Content-Type': 'application/vnd.api+json',
        }
    }

    filterProjectByCurrentPermission(projects: Record<string, any>, name: string) {
        let res = projects
            ? Object.values(projects).filter((project: any) => {
                  return this.hasPermission(project.attributes.permissions, name)
              })
            : projects

        return res
    }

    // ROLES
    async getProjectRoles(id: string) {
        let url = `${this.url_authorization}/projects/${id}?include=roles.availablePermissions,roles.permissions,roles.includedPermissions`
        let res = await getRequest(url, this.headersmixins)

        let roles: any = []

        res.data.included.map((item: any) => {
            switch (item.type) {
                case 'role':
                    roles.push(item)
                    break
            }
        })

        return roles
    }

    async getRoles() {
        if (!this.currentProjectId) return

        let query = {
            include: [
                'roles.permissions',
                'roles.includedPermissions',
                'roles.availablePermissions',
            ],
        }

        let res = await Vue.prototype.$vbit.get(
            'authorization',
            `projects/${this.currentProjectId}`,
            query
        )

        let roles: Role[] = []
        res.included.forEach((item) => {
            if (item._type === 'permission') {
                this.rolePermissions[item._id] = item
            }
            if (item._type === 'role') {
                roles.push(item)
            }
        })

        this.$store.commit('roles', roles)

        this.roles = roles
    }

    async patchRole(params: any) {
        let url = `${this.url_authorization}/roles/${params.data.id}?include=availablePermissions,permissions,includedPermissions`
        let res = await patchRequest(url, this.headersmixins, params.data)
        return res.data.data
    }

    async postRole(data: any) {
        let url = `${this.url_authorization}/roles?include=availablePermissions,permissions,includedPermissions`
        let res = await postRequest(url, this.headersmixins, data)
        return res.data.data
    }

    // PERMISSIONS
    async getAllPermissions() {
        let url = `${this.url_authorization}/permissions?include=included`
        let res = await getRequest(url, this.headersmixins)
        return res
    }

    // PROJECT USERS
    getRequestHeaders(arg0: string): any {
        throw new Error('Method not implemented.')
    }
    getURL(arg0: { path: string; base: any; params: { include: string } }): string {
        throw new Error('Method not implemented.')
    }
}
